import React from "react";
import { useSelector } from "react-redux";

import { ROLES } from "../../../../utils";
import { UserCourses } from "./UserCourses";
import { Loader } from "../../../../components";

export function Courses() {
  const { loading } = useSelector((state) => state.app);

  const {
    user,
    userCourses,
  } = useSelector((state) => state);

  if (loading) {
    return <Loader delay={0.85} />;
  }

  if (
    user?.roleId !== ROLES.admin &&
    userCourses.length === 0
  ) {
    return (
      <div className="modern-empty-courses">

        <div className="modern-empty-icon">
          <i className="fas fa-book-open" />
        </div>

        <h3>Aún no tienes cursos asignados</h3>

        <p>
          Cuando tengas una capacitación disponible aparecerá
          automáticamente en esta sección.
        </p>

      </div>
    );
  }

  return (
    <div className="modern-course-grid">

      {userCourses.map((userCourse) => (
        <UserCourses
          key={userCourse.id}
          id={userCourse.course_id}
          title={
            userCourse.course_title ||
            "Curso de capacitación"
          }
          isActive={userCourse.is_active}
          finished={userCourse.finished}
          percAvan={userCourse.percentage_course}
          percCal={userCourse.qualification_course}
        />
      ))}

    </div>
  );
}